import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { niuNiu } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A NIU NIU TABLE PLAYED ON THREE SHARED BOXES */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={niuNiu.api} config={niuNiu} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
